/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components, getter-return */
// Ember imports
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
// Internal imports
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';

export default class AttendanceIndividualTable extends Component {
  // Defaults
  // individualTermTotals is the total number of individual attendance in each term per code
  @tracked individualTermTotals = null;

  // periods is the school's format of recording attendance
  periods = null;

  @tracked jurisdiction = null;

  @computed('jurisdiction')
  get trackMovements() {
    return this.jurisdiction !== Jurisdiction.NZ_MOE;
  }

  // termTotals has total codes counts and percentages per term
  @computed('individualTermTotals', 'trackMovements')
  get termsTotals() {
    return this.individualTermTotals.map((term) => {
      let presentCount = term.present || 0;
      let lateCount = term.late || 0;
      if (!this.trackMovements) {
        // Include late counts for NZ MoE schools
        presentCount += lateCount;
      }
      let justifiedCount = term.justified || 0;
      let unjustifiedCount = term.unjustified || 0;

      let presentPercentage = ((presentCount / term.total) * 100).toFixed(1);
      let justifiedPercentage = ((justifiedCount / term.total) * 100).toFixed(
        1,
      );
      let unjustifiedPercentage = (
        (unjustifiedCount / term.total) *
        100
      ).toFixed(1);
      let latePercentage = ((lateCount / term.total) * 100).toFixed(1);
      return {
        term: term.term,
        present: presentCount,
        presentPercentage: presentPercentage,
        justified: justifiedCount,
        justifiedPercentage: justifiedPercentage,
        unjustified: unjustifiedCount,
        unjustifiedPercentage: unjustifiedPercentage,
        late: lateCount,
        latePercentage: latePercentage,
        total: term.total,
      };
    });
  }

  // ytdTotals is the total number of termly attendance in the current year
  get ytdTotals() {
    if (isEmpty(this.termsTotals)) {
      // We can't use the array further down as it's empty
      return;
    }

    let counts = this.termsTotals.reduce(
      (ytd, term) => {
        ytd.present += term.present;
        ytd.justified += term.justified;
        ytd.unjustified += term.unjustified;
        ytd.late += term.late;
        ytd.total += term.total;

        return ytd;
      },
      {
        present: 0,
        justified: 0,
        unjustified: 0,
        late: 0,
        total: 0,
      },
    );

    counts.presentPercentage = ((counts.present / counts.total) * 100).toFixed(
      1,
    );
    counts.justifiedPercentage = (
      (counts.justified / counts.total) *
      100
    ).toFixed(1);
    counts.unjustifiedPercentage = (
      (counts.unjustified / counts.total) *
      100
    ).toFixed(1);
    counts.latePercentage = ((counts.late / counts.total) * 100).toFixed(1);

    return counts;
  }
}
